// import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography } from "@mui/material";

// // TableCell style, do NOT set font size, just use default
// const cellSx = {
//   backgroundColor: "rgba(47, 53, 71, 0.9)",
//   border: "1.5px solid #fff",
//   color: "white",
//   padding: '10px 8px',
// };
// const numberSx = {
//   ...cellSx,
//   textAlign: 'left',
//   fontWeight: 600,
// };

// const InternalResignationTable = ({
//   salary = 0,
//   christmasBonus = 0,
//   overtime = 0,
//   nightBonus = 0,
//   accruedVacation = 0,
//   deductions = 0,
//   total = 0
// }) => {

//   // Data rows as arrays for easy mapping and styling
//   const rows = [
//     ["Actual Salary", salary, "For the last month or days worked"],
//     ["Christmas Bonus", christmasBonus, "Proportional if not yet paid"],
//     ["Overtime", overtime, "Sum of all pending overtime"],
//     ["Night Shift Bonus", nightBonus, "For last period, if applicable"],
//     ["Accrued Vacations", accruedVacation, "Only if over 1 year service"],
//     ["Deductions", `-${deductions}`, "Advances, loans, etc."],
//   ];

//   return (
//     <Box mt={4}>
//       <Typography variant="h6" mb={2} fontWeight="bold" color="white">
//         Internal Resignation Settlement
//       </Typography>
//       <TableContainer component={Paper} sx={{ background: 'rgba(47, 53, 71, 0.9)' }}>
//         <Table>
//           <TableBody>
//             {rows.map((row, rowIndex) => (
//               <TableRow key={rowIndex}>
//                 <TableCell sx={cellSx}>{row[0]}</TableCell>
//                 <TableCell
//                   sx={{
//                     ...numberSx,
//                     color: row[0].toLowerCase().includes("deduction") ? 'red'
//                     : row[0] === "IPS Severance" ? '#3afa60'
//                     : "white"
//                   }}
//                 >
//                   {row[1]}
//                 </TableCell>
//                 <TableCell sx={cellSx}>{row[2]}</TableCell>
//               </TableRow>
//             ))}
//             {/* Total Row: merge last two columns */}
//             <TableRow>
//               <TableCell sx={{ ...cellSx, fontWeight: 700 }}>
//                 Total to Pay
//               </TableCell>
//               <TableCell
//                 colSpan={2}
//                 sx={{
//                   ...numberSx,
//                   background: "rgba(34,189,110,0.15)",
//                   color: "#3afa60",
//                   fontWeight: "bold",
//                   textAlign: 'center',
//                   fontSize: 20,
//                 }}
//               >
//                 {total}
//               </TableCell>
//             </TableRow>
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   );
// };

// export default InternalResignationTable;



import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography } from "@mui/material";

// TableCell style, do NOT set font size, just use default
const cellSx = {
  backgroundColor: "rgba(47, 53, 71, 0.9)",
  border: "1.5px solid #fff",
  color: "white",
  padding: '10px 8px',
};
const numberSx = {
  ...cellSx,
  textAlign: 'left',
  fontWeight: 600,
};

const InternalResignationTable = ({
  salary = 0,
  christmasBonus = 0,
  overtime = 0,
  nightBonus = 0,
  accruedVacation = 0,
  deductions = 0,
  total = 0
}) => {

  // Data rows as arrays for easy mapping and styling
  const rows = [
    ["Salario Actual", salary, "Durante el último mes o días trabajados"],
    ["Aguinaldo", christmasBonus, "Proporcional O Causada"],
    ["Horas Extras", overtime, "Suma de todas las horas extras"],
    ["Adicional Nocturno", nightBonus, "Para el último período, si corresponde"],
    ["Vacaciones Causadas", accruedVacation, "Sólo si tiene más de 1 año de servicio"],
    ["Descuentos", `-${deductions}`, "Anticipos, préstamos, etc."],
  ];

  return (
    <Box mt={4}>
      <Typography variant="h6" mb={2} fontWeight="bold" color="white">
        Renuncia Interna - Liquidación
      </Typography>
      <TableContainer component={Paper} sx={{ background: 'rgba(47, 53, 71, 0.9)' }}>
        <Table>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableCell sx={cellSx}>{row[0]}</TableCell>
                <TableCell
                  sx={{
                    ...numberSx,
                    color: row[0].toLowerCase().includes("descuento") ? 'red'
                    : row[0] === "IPS Severance" ? '#3afa60'
                    : "white"
                  }}
                >
                  {row[1]}
                </TableCell>
                <TableCell sx={cellSx}>{row[2]}</TableCell>
              </TableRow>
            ))}
            {/* Total Row: merge last two columns */}
            <TableRow>
              <TableCell sx={{ ...cellSx, fontWeight: 700 }}>
                Total a Pagar
              </TableCell>
              <TableCell
                colSpan={2}
                sx={{
                  ...numberSx,
                  background: "rgba(34,189,110,0.15)",
                  color: "#3afa60",
                  fontWeight: "bold",
                  textAlign: 'center',
                  fontSize: 20,
                }}
              >
                {total}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default InternalResignationTable;
